import { URL_LABEL } from "../../../../content/index.content";

const onDemandTraining = ({ language, isSavedUser }) => {
  return {
    title: "On-Demand Training",
    subtitle:
      "Learn how to sell on Amazon with the best comprehensive courses from 7-figure eCommerce sellers",
    href: isSavedUser
      ? `/app/#/university?${URL_LABEL}`
      : `/university?${URL_LABEL}`,
    extraTitle: true,
    isLink: !isSavedUser,
  };
};

export default onDemandTraining;
